// assets/size-chart-drawer.js

// mark that the script loaded
console.log('[size-chart] script loaded');

document.addEventListener('click', function (e) {
  const openBtn = e.target.closest('[data-size-drawer-open]');
  const closeBtn = e.target.closest('[data-size-drawer-close]');
  const underlay = e.target.closest('[data-size-drawer-underlay]');
  const drawer = document.getElementById('size-chart-drawer');

  if (!drawer) {
    if (openBtn || closeBtn || underlay) {
      console.warn('[size-chart] drawer element not found');
    }
    return;
  }

  // Open
  if (openBtn) {
    e.preventDefault();
    console.log('[size-chart] open clicked', openBtn);
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.documentElement.classList.add('scroll-locked');
    // focus first focusable in drawer if available
    const focusTarget = drawer.querySelector('[data-size-drawer-close], button, a, input, select, textarea');
    (focusTarget || drawer).focus();
    console.log('[size-chart] drawer opened');
  }

  // Close via button or underlay
  if (closeBtn || underlay) {
    console.log('[size-chart] close clicked', closeBtn || underlay);
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('scroll-locked');
    console.log('[size-chart] drawer closed');
  }
});

// Close on Escape
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    const drawer = document.getElementById('size-chart-drawer');
    if (drawer && drawer.classList.contains('is-open')) {
      console.log('[size-chart] escape key close');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('scroll-locked');
      console.log('[size-chart] drawer closed');
    }
  }
});

// Toggle CM / INCHES
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.size-toggle-btn');
  if (!btn) return;
  const unit = btn.dataset.sizeUnit;
  document.querySelectorAll('.size-toggle-btn').forEach(b => b.classList.remove('is-active'));
  btn.classList.add('is-active');
  document.querySelectorAll('[data-size-image]').forEach(img => {
    img.classList.toggle('hidden', img.dataset.sizeImage !== unit);
  });
});

